import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Text } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { getSectionSpacing } from '../../sections/Section/Section.js';
import { Link } from '../Link/Link.js';

var TopWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n    height: 36px;\n    display: flex;\n    align-items: center;\n  "], ["\n    border-bottom: 1px solid ", ";\n    height: 36px;\n    display: flex;\n    align-items: center;\n  "])), theme.designTokens.colors.grey30);
});
var Top = styled.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    list-style: none;\n    display: flex;\n    justify-content: flex-end;\n    gap: ", ";\n    width: 100%;\n\n    ", "\n  "], ["\n    position: relative;\n    list-style: none;\n    display: flex;\n    justify-content: flex-end;\n    gap: ", ";\n    width: 100%;\n\n    ", "\n  "])), theme.spacing[4], getSectionSpacing({
    theme: theme,
    xPadding: [2, 8, 12, 24],
    yPadding: 1
  }));
});
var Label = styled(Link)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: 16px;\n    line-height: 20px;\n    color: ", ";\n  "], ["\n    font-size: 16px;\n    line-height: 20px;\n    color: ", ";\n  "])), theme.designTokens.colors.primary60);
});
/**
 * The NavigationTop component.
 */
var NavigationTop = function (_a) {
  var top = _a.top,
    hideMenu = _a.hideMenu;
  return top ? jsx(TopWrapper, {
    onMouseEnter: hideMenu,
    children: jsx(Top, {
      children: top.map(function (_a, index) {
        var to = _a.to,
          title = _a.title;
        return jsx(Text, {
          as: "li",
          type: "label",
          children: jsx(Label, {
            to: to,
            children: title
          })
        }, index);
      })
    })
  }) : null;
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { NavigationTop };
//# sourceMappingURL=NavigationTop.js.map
